<ng-container contentTop *ngIf="showContentTop">
  <div class="content-header-wrapper">
    <pl-lib-header-content-layout
      [title]="title"
      [subTitle]="subTitle"
      [actions]="actions"
    ></pl-lib-header-content-layout>
  </div>
</ng-container>
<div class="content">
 <pl-entity-list *ngIf="gridType==='grid'" [configurator]="$any(configurator.gridConfigurator)"></pl-entity-list>
 <pl-tree-list *ngIf="gridType==='treeList'" [configurator]="$any(configurator.gridConfigurator)"></pl-tree-list>
</div>
